import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import LinearProgress from '@material-ui/core/LinearProgress';
import loader_img from "../public/loader__img.png"
const useStyles = makeStyles((theme) => ({
  root: {
    width: '15%',
    '& > * + *': {
      marginTop: theme.spacing(2),
    },
    margin:"auto"
  },
  load : {
    width: "70%",
    height:"2.5px",
    margin: "20px auto",
    background: "#e1bdff",

  }
}));

export default function CustomLoader() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
            <img src={loader_img}></img>

        {/* <img src = "" ></img> */}
      <LinearProgress className = {classes.load}/>
    </div>
  );
}
